import * as React from 'react';

import { st, classes } from './Description.st.css';
import { useEnvironment } from '@wix/yoshi-flow-editor';

interface IDescriptionProps {
  description: string;
}

export const Description: React.FC<IDescriptionProps> = ({ description }) => {
  const { isMobile, isEditorX } = useEnvironment();

  if (!description) {
    return null;
  }

  return (
    <p
      className={st(classes.root, {
        mobileView: isMobile,
        fluid: isEditorX,
      })}
      data-hook="item-description"
      dangerouslySetInnerHTML={{ __html: description }}
    />
  );
};
